export const COMMUNITY_PORTAL = {
  BASE_URL: "https://community.appsmith.com",
};
